module.exports = __webpack_public_path__ + "img/weibo-code.58a3a435.png";